import React from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
export default function WeAreHereForYou() {
  return <section data-section-id="224505" id="emergency-dispatch" className="dark bg-background text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8 border-t border-border">
      <div className="max-w-4xl mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-primary/10 border border-primary/20 mb-6">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-lg bg-primary opacity-75"></span>
            <span className="relative inline-flex rounded-lg h-2 w-2 bg-primary"></span>
          </span>
          <span className="text-xs font-mono font-bold uppercase tracking-widest text-primary">
            Dispatch Status: Active
          </span>
        </div>
        <h2 className="text-3xl md:text-5xl font-default font-bold mb-4 tracking-tighter uppercase">
          Ongoing Support
        </h2>
        <p className="text-lg text-muted-foreground mb-12 max-w-2xl mx-auto font-default">
          Reliable maintenance and rapid-response field services. Whether it's routine infrastructure care or an urgent technical outage, our Kansas City teams are ready to deploy.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <Card className="bg-card border-border/50 shadow-2xl hover:shadow-primary/5 transition-all duration-300">
            <CardContent className="p-8 flex flex-col items-center justify-center text-center h-full">
              <div className="h-16 w-16 bg-primary/10 flex items-center justify-center mb-6 text-primary">
                <Phone className="w-8 h-8" />
              </div>
              <span className="text-xs font-mono font-medium text-muted-foreground uppercase tracking-widest mb-3">
                Emergency Contact
              </span>
              <Link to="tel:+18165550199" className="text-3xl md:text-5xl font-default font-bold text-primary hover:text-primary/80 transition-colors tracking-tighter">913-636-8169</Link>
            </CardContent>
          </Card>

          <Card className="bg-card border-border/50 shadow-2xl hover:shadow-primary/5 transition-all duration-300">
            <CardContent className="p-8 flex flex-col items-center justify-center text-center h-full">
              <div className="h-16 w-16 bg-primary/10 flex items-center justify-center mb-6 text-primary">
                <Mail className="w-8 h-8" />
              </div>
              <span className="text-xs font-mono font-medium text-muted-foreground uppercase tracking-widest mb-3">
                Immediate Response
              </span>
              <Link to="#" className="text-2xl md:text-3xl font-default font-semibold text-foreground hover:text-primary transition-colors uppercase tracking-tight">
                Request Field Tech
              </Link>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}